export enum ScriptType {
    ACUTE,
    CHRONIC,
    Historical,
    Hemodialysis,
    Erythropoietin
}
